import tw from 'twin.macro';

export const Wrapper = tw.div`flex flex-col p-[12px] rounded-lg border border-gray-1 flex-1 gap-[10px] justify-between`;
export const Header = tw.div`flex justify-between items-center`;
export const Title = tw.h3`text-[14px] font-semibold text-text-and-icon self-start`;
export const Subtitle = tw.div`text-[11px] font-normal text-text-and-icon-muted text-start`;
export const Footer = tw.div`flex justify-end items-center self-stretch`;
export const SeeMoreButton = tw.button`flex justify-center items-center text-[12px] h-[26px] border border-gray-1 rounded px-[10px] cursor-pointer text-text-and-icon`;
export const NoDataAvailable = tw.div`text-text-and-icon`;

export const Table = tw.div`flex flex-col gap-[10px]`;
export const TableRow = tw.div`grid gap-[12px] px-[8px] items-center`;
export const TableHeader = tw(TableRow)`rounded-[3px] bg-accent-2 h-[20px]`;
export const TableHeaderCell = tw.div`flex text-[11px] text-text-and-icon-invert font-bold truncate`;
export const TableBody = tw.div`flex flex-col gap-[10px]`;
export const TableBodyRow = tw(TableRow)`h-[16px]`;
export const TableBodyCell = tw.div`flex text-[12px] font-semibold text-text-and-icon truncate`;

export const RiskLevelLegend = tw.div`flex gap-[12px] font-medium`;
export const RiskLevelLegendItem = tw.div`flex gap-[8px] items-center text-[12px] text-text-and-icon`;

export const ChartWrapper = tw.div`flex w-full gap-[12px] justify-start items-start`;
export const ChartLegend = tw.div`flex flex-col justify-between h-full py-[2px] whitespace-nowrap`;
export const ChartLegendItem = tw.div`flex gap-[12px] items-center justify-end`;
export const ChartLegendCount = tw.div`flex h-[18px] items-center whitespace-nowrap`;

export const OuterChartsWrapper = tw.div` grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 p-4 justify-items-center`;
export const ChartsWrapper = tw.div`flex flex-col gap-[12px] justify-start items-center rounded cursor-pointer w-[112px] p-[4px]`;
export const CategoryTitle = tw.div`text-[12px] text-text-and-icon font-medium line-clamp-3 text-center`;

export const RelatednessLabel = tw.div`text-[56px] font-bold text-garm-high-bg leading-tight`;
export const UnrelatednessLabel = tw.div`text-[40px] font-bold text-garm-unrelated-muted leading-tight`;

export const SeeEpisodesButtonWrapper = tw.div`flex items-center justify-end max-w-[40px] max-h-[40px] cursor-pointer`;
